import React from 'react';
import  { useEffect , useRef } from 'react'
import {Container} from 'semantic-ui-react';
import Box from '@mui/material/Box';
import Moment from 'moment';

import useGetRoutesExpressById from '../../../../hooks/getRoutesExpressById';
import useGetDataDispachstGroup from '../../../../hooks/getDataDispachstGroup';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import DashRoutesAddMap from './DashRoutesAddMap';
import FmdBadIcon from '@mui/icons-material/FmdBad';




const DashRoutesAdd = (props) => {
  
  const usuarioStorage = JSON.parse(localStorage.getItem('usuario'))
  const LocalRol = usuarioStorage.roll;
  const usuarioLocal = usuarioStorage.uid;

  var companyId=null
  const [succesCreate,setSuccesCreate] = React.useState(true);
  const [targetedOrdersRows, setTargetedOrdersRows]  = React.useState('');
  const [targetedOrdersCancel, setTargetedOrdersCancel]  = React.useState('');
  const [targetedOrdersDelivered, setTargetedOrdersDelivered]  = React.useState('');
  const[OrderID, setOrderID ] = React.useState(''); // Buscar una orden => setOrderID
  //const[currentOrderList, setCurrentOrderList] = React.useState([]);
  var [newRoute,setNewRoute] = React.useState(null);
  const [OrdersRows, setOrdersRows]  = React.useState('');
  const [routeWaypoints, setRouteWaypoints] = React.useState([]);
  const [routeArraypoints, setRouteArraypoints] = React.useState([]);

  const [newdurationValue,setdurationValue]=React.useState("")
  const [newdestination,setdestination]=React.useState("")
  const [newsetRoutePoints,setsetRoutePoints]=React.useState("")
  const [newcurrentOrderList,setcurrentOrderList]=React.useState("")
  const [saveCurrentOrderList,setSaveCurrentOrderList]=React.useState("")
  
  const [newdispacthPartials,setdispacthPartials]=React.useState("")
  const [newdate,setdate]=React.useState("")
  const [newwayPoints,setwayPoints]=React.useState("")
  const [newcreateBy,setcreateBy]=React.useState("")
  const [newdistanceValue,setdistanceValue]=React.useState("")
  const [newtravelMode,settravelMode]=React.useState("")
  const [newdateDeliveryText,setdateDeliveryText]=React.useState("")
  const [newcompanyId,setcompanyId]=React.useState("")
  const [newdriverName,setdriverName]=React.useState("")
  const [newdispacthDelyvery,setdispacthDelyvery]=React.useState("")
  const [newfullCompliance,setfullCompliance]=React.useState("")
  const [newoptimizeWaypoints,setoptimizeWaypoints]=React.useState("")
  const [neworigin, setneworigin] = React.useState("")
  const [newvehicleID,setvehicleID]=React.useState("")
  const [newwaypoint_order,setwaypoint_order]=React.useState("")
  const [newisDelete,setisDelete]=React.useState("")
  const [newdateDelivery,setdateDelivery]=React.useState("")
  const [newcreateDate,setcreateDate]=React.useState("")
  const [newwarnings,setwarnings]=React.useState("")
  const [newendTimeDelivery,setendTimeDelivery]=React.useState("")
  const [newid,setid]=React.useState("")
  const [newdispacthNotDelyvery,setdispacthNotDelyvery]=React.useState("")
  const [newdriverID,setdriverID]=React.useState("")
  const [newstartTimeDelivery,setstartTimeDelivery]=React.useState("")
  const [newmaxTimeDelivery,setmaxTimeDelivery]=React.useState("")
  const [newisActive,setisActive]=React.useState("")
  const [markerpoint, setmarkerpoint]=React.useState(null)
  const [allCharge, setAllCharge] =React.useState(false)
  const [newLegs,setlegs]=React.useState("")
  const [visibleMaps, setVisibleMaps] = React.useState(false)
  const[responseApi, setResposeApi] = React.useState(null)
  
  const dragItem = useRef();
  const dragOverItem = useRef();
  var responseApiGoogle
  
  const { bicciRoutesExpressByID, loadRoutesExpressByID, errorRoutesExpressByID } = useGetRoutesExpressById(companyId,LocalRol , props.match.params.id)
  const { bicciOrderExpressGroup, loadOrderExpressGroup, errorOrderExpressGroup} = useGetDataDispachstGroup(companyId,LocalRol,newcurrentOrderList)
  //const { bicciOrderExpressOutGroup, loadOrderExpressOutGroup, errorOrderExpressOutGroup} = useGetDataDispachstOutGroup(companyId,LocalRol)
  useEffect(()=>{
    // console.log(bicciRoutesExpressByID)
    if(loadRoutesExpressByID){
      setdurationValue(bicciRoutesExpressByID.durationValue)
      setdestination(bicciRoutesExpressByID.destination)
      setsetRoutePoints(bicciRoutesExpressByID.setRoutePoints)
      setcurrentOrderList(bicciRoutesExpressByID.currentOrderList)
      setdispacthPartials(bicciRoutesExpressByID.dispacthPartials)
      setdate(bicciRoutesExpressByID.date)
      setwayPoints(bicciRoutesExpressByID.wayPoints)
      setcreateBy(bicciRoutesExpressByID.createBy)
      setdistanceValue(bicciRoutesExpressByID.distanceValue)
      settravelMode(bicciRoutesExpressByID.travelMode)
      setdateDeliveryText(bicciRoutesExpressByID.dateDeliveryText)
      setcompanyId(bicciRoutesExpressByID.companyId)
      setdriverName(bicciRoutesExpressByID.driverName)
      setdispacthDelyvery(bicciRoutesExpressByID.dispacthDelyvery)
      setfullCompliance(bicciRoutesExpressByID.fullCompliance)
      setneworigin(bicciRoutesExpressByID.origin)
      setoptimizeWaypoints(false)
      setvehicleID(bicciRoutesExpressByID.vehicleID)
      setwaypoint_order(bicciRoutesExpressByID.waypoint_order)
      setisDelete(bicciRoutesExpressByID.isDelete)
      setdateDelivery(bicciRoutesExpressByID.dateDelivery)
      setcreateDate(bicciRoutesExpressByID.createDate)
      setwarnings(bicciRoutesExpressByID.warnings)
      setendTimeDelivery(bicciRoutesExpressByID.endTimeDelivery)
      setid(bicciRoutesExpressByID.id)
      setdispacthNotDelyvery(bicciRoutesExpressByID.dispacthNotDelyvery)
      setdriverID(bicciRoutesExpressByID.driverID)
      setstartTimeDelivery(bicciRoutesExpressByID.startTimeDelivery)
      setmaxTimeDelivery(bicciRoutesExpressByID.maxTimeDelivery)
      setisActive(bicciRoutesExpressByID.isActive)
      setAllCharge(true)
      
    }  
  
    },[bicciRoutesExpressByID ])

    useEffect(()=>{
      if(allCharge){
      //printValues() 
      accionSecuense()
       }
      },[allCharge , bicciOrderExpressGroup ])
        
    const accionSecuense = () => {
      UpdateArrayOrders()
    }
    const handleVisibleMaps = () => {
      setVisibleMaps(!visibleMaps)
    }
  /**
  * FILTRAR ORDENES PARA ASIGNACION
  */
 
  const UpdateArrayOrders  = () =>{
      if(bicciOrderExpressGroup ){
          let opsList = [];
  
         var bicciReOrderExpressGroup = []
         var targetedOrdersRowsTemp = []
         var targetedOrdersRowsComplete = []
         var targetedOrdersRowsCancel = []

    
        function getestimatedDeliveryTime(i){
          if(bicciRoutesExpressByID.legs[i] && bicciRoutesExpressByID.legs[i]){
            return bicciRoutesExpressByID.legs[i].estimatedDeliveryTime
          }else{ return 'no time'}

        }

         for (let i = 0; i < bicciOrderExpressGroup.length; i++) {
          if(bicciOrderExpressGroup[i].status < 0){
            targetedOrdersRowsCancel.push ({ id: bicciOrderExpressGroup[i].id , toAddress: bicciOrderExpressGroup[i].toAddress, toAddressLocation:bicciOrderExpressGroup[i].toAddressLocation, userName: bicciOrderExpressGroup[i].userName, userPhone:bicciOrderExpressGroup[i].userPhone, status:bicciOrderExpressGroup[i].status, express:bicciOrderExpressGroup[i].express, });
           
            }
          if((bicciOrderExpressGroup[i].status >= 0) && (bicciOrderExpressGroup[i].status <= 7)){
            targetedOrdersRowsTemp.push ({ id: bicciOrderExpressGroup[i].id , toAddress: bicciOrderExpressGroup[i].toAddress, toAddressLocation:bicciOrderExpressGroup[i].toAddressLocation, userName: bicciOrderExpressGroup[i].userName, userPhone:bicciOrderExpressGroup[i].userPhone, status:bicciOrderExpressGroup[i].status, express:bicciOrderExpressGroup[i].express, estimatedDeliveryTime: getestimatedDeliveryTime(i)});

            }
          if(bicciOrderExpressGroup[i].status >= 8){
            targetedOrdersRowsComplete.push ({ id: bicciOrderExpressGroup[i].id , toAddress: bicciOrderExpressGroup[i].toAddress, toAddressLocation:bicciOrderExpressGroup[i].toAddressLocation, userName: bicciOrderExpressGroup[i].userName, userPhone:bicciOrderExpressGroup[i].userPhone, status:bicciOrderExpressGroup[i].status, express:bicciOrderExpressGroup[i].express , });

            }
        }

        for (let i = 0; i < targetedOrdersRowsTemp.length; i++) {
          opsList.push(targetedOrdersRowsTemp[i].id)
        }
        for (let i = 0; i < targetedOrdersRowsComplete.length; i++) {
          opsList.push(targetedOrdersRowsComplete[i].id)
        }
        for (let i = 0; i < targetedOrdersRowsCancel.length; i++) {
          opsList.push(targetedOrdersRowsCancel[i].id)
        }
     
        setSaveCurrentOrderList(opsList)
        // console.log(opsList)
        bicciReOrderExpressGroup.concat(targetedOrdersRowsTemp,targetedOrdersRowsComplete,targetedOrdersRowsCancel)
        // console.log(targetedOrdersRowsTemp)
        setTargetedOrdersRows(targetedOrdersRowsTemp)
        setTargetedOrdersCancel(targetedOrdersRowsCancel)
        setTargetedOrdersDelivered(targetedOrdersRowsComplete)
        
        UpdateMapWaitPoints(targetedOrdersRowsTemp)
    }
  }

  const UpdateMapWaitPoints = (targetedOrdersRows) =>{
      if(targetedOrdersRows){
        //// console.log('ACTUALIZAR MAPA')
                 //// console.log(currentOrderList)
                  let tempWayPoints  = []
                  for (let i = 0; i < targetedOrdersRows.length; i++) {
                    var location = new Object();
                      location.lng=parseFloat(targetedOrdersRows[i].toAddressLocation.longitude);
                      location.lat=parseFloat(targetedOrdersRows[i].toAddressLocation.latitude);
                      let point = {
                        "location":location,
                        "stopover":true,
                      };
                      tempWayPoints.push(point) 
                }
                setwayPoints(tempWayPoints)
                updateMaps()
           
      }else( console.log('SIN OBJETIVOS'))
  }

  const printValues = () =>{
    // console.log(newdurationValue);
    // console.log(newdestination);
    // console.log(newsetRoutePoints);
    // console.log(newcurrentOrderList);
    // console.log(newdispacthPartials);
    // console.log(newdate);
    // console.log(newwayPoints); // Obligatorio
    // console.log(newcreateBy);
    // console.log(newdistanceValue);
    // console.log(newtravelMode);
    // console.log(newdateDeliveryText);
    // console.log(newcompanyId);
    // console.log(newdriverName);
    // console.log(newdispacthDelyvery);
    // console.log(newfullCompliance);
    // console.log(newoptimizeWaypoints);
    // console.log(neworigin)
    // console.log(newvehicleID);
    // console.log(newwaypoint_order); // Response
    // console.log(newisDelete);
    // console.log(newdateDelivery);
    // console.log(newcreateDate);
    // console.log(newwarnings); // Opcional
    // console.log(newendTimeDelivery);
    // console.log(newid);
    // console.log(newdispacthNotDelyvery);
    // console.log(newdriverID);
    // console.log(newstartTimeDelivery);
    // console.log(newmaxTimeDelivery);
    // console.log(newisActive);
  }

  const dragStart = (e, position) => {
    dragItem.current = position;
  };

  const dragEnter = (e, position) => {
    dragOverItem.current = position;
  };

  const drop = (e) => {
    const copyListItems = [...targetedOrdersRows];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    setTargetedOrdersRows(copyListItems);
    UpdateMapWaitPoints(copyListItems)
    setoptimizeWaypoints(false)
  };

  const changeIndex = (e, index) => {
    dragItem.current = index;
    dragOverItem.current = e.target.value;
    drop(e.currentTarget.parentNode)
  };

  const handleresposeapi=(response)=>{

    if(response.routes[0].legs && response.routes[0].legs.length >0 ){

    let inputsDate = []
    inputsDate = newdateDeliveryText.toString()
    inputsDate = inputsDate.split("-")
    var startTime = new Date(inputsDate[2],inputsDate[1],inputsDate[0]) 
    let inputs; 
    let input;
    let estimatedDeliveryMin;
    let estimateDeliveryHour;
    var estimateTemp;
    var estimateTotal = 0
    input = newstartTimeDelivery.toString()
    inputs = newstartTimeDelivery.split(":")
    startTime.setMinutes((parseInt(inputs[0])*60) + parseInt(inputs[1]))


    function getTimeSecons(duration){
      //// console.log(duration.value)

      estimateTotal += parseInt(duration.value/60)

      estimateTemp = parseInt(Math.round(duration.value/60)+15)

      startTime.setMinutes((parseInt(inputs[0])) + parseInt(inputs[1]) + estimateTotal + 10)
      
      return Moment(startTime).format('DD MMMM YYYY, HH:mm')

    }

    responseApiGoogle = response.routes[0].legs
     .map(goLegs => ({
      "distance":goLegs.distance,
      "duration": goLegs.duration,
      "estimatedDeliveryTime": getTimeSecons(goLegs.duration),
      "start_address": goLegs.start_address,
      "start_location": goLegs.start_location.toJSON(),
      "end_address": goLegs.end_address,
      "end_location": goLegs.end_location.toJSON(),
    }))

    function delay2() {
      setwaypoint_order(response.routes[0].waypoint_order)

      setlegs(responseApiGoogle)
   }
   setTimeout(delay2, 3000);

  }

  }

  const updateMaps = () => {
  
 
    return <DashRoutesAddMap 
          origin={neworigin} 
          destination={newdestination} 
          travelmodel={newtravelMode} 
          optimizewaypoints={newoptimizeWaypoints} 
          waypoints={newwayPoints} 
          handleresposeapi={handleresposeapi}
          targetedordersrows={targetedOrdersRows}
          targetedorderscancel={targetedOrdersCancel}
          targetedordersdelivered={targetedOrdersDelivered} 
          markerpoint={markerpoint}
          /> 
  }

  const handleOptimize = () =>{
    UpdateArrayOrders()
    setoptimizeWaypoints(true)
    updateMaps()
    
  }

  const handleRemoveItem = (e,index) => {
    e.preventDefault()
    // console.log('accion remove')
    //// console.log(newcurrentOrderList)

    let removeItem =  Object.values(newcurrentOrderList);
    
    var newArray = removeItem.filter((item) => item !== newcurrentOrderList[index]);
    //// console.log(newArray);
    setcurrentOrderList(newArray)
    accionSecuense()
    updateMaps()

  }
  const handleClickPeriscope =(e,item) =>{

    setmarkerpoint(item)
    setVisibleMaps(null)
    function delay() {
      setVisibleMaps(true)
    }
    setTimeout(delay, 500);

    

  }

  const saveNewRoute = async() => {
    var newRoute= 
      {
        createBy: newcreateBy,
        createDate:newcreateDate,
        date:newdate,
        id:newid,
        vehicleID:newvehicleID,
        driverID:newdriverID,
        driverName:newdriverName,
        companyId:newcompanyId,
        currentOrderList:saveCurrentOrderList,
        origin :neworigin,
        destination :newdestination,
        optimizeWaypoints:newoptimizeWaypoints,
        wayPoints:newwayPoints,
        waypoint_order:newwaypoint_order,
        maxTimeDelivery:newmaxTimeDelivery,
        dateDeliveryText:newdateDeliveryText,
        dateDelivery:newdateDelivery,
        startTimeDelivery:newstartTimeDelivery,
        endTimeDelivery:newendTimeDelivery,
        distanceValue:newdistanceValue,
        durationValue:newdurationValue,
        setRoutePoints:newsetRoutePoints,
        dispacthDelyvery:newdispacthDelyvery,
        dispacthPartials:newdispacthPartials,
        dispacthNotDelyvery:newdispacthNotDelyvery,
        fullCompliance:newfullCompliance,
        warnings:newwarnings,
        isDelete:newisDelete,
        isActive:newisActive,
        lastModify:Date.now().toString(),
        legs: newLegs,

     };
     // console.log(newRoute)
     //await db.collection(`${process.env.REACT_APP_COL_ROUTES}`).doc(newid).update(newRoute);
     //histoy
     //await db.collection(`${process.env.REACT_APP_COL_ROUTES}`).doc(newid).collection('history').doc(Date.now().toString()).set(newRoute);
  } 

  return !loadRoutesExpressByID? (  
    <div>
     
       <div className="topflex">
       <div className='dashroutesadd_bar'>  
           <div className='dashroutesadd_bar_top'>
              <div className='dashroutesadd_bar_top_left'>
                <span>{`Rutas > Guias de despacho`}</span>
              </div>
              <div className='dashroutesadd_bar_top_right'>
                
                {
                  !succesCreate?(<div>
                    <div className="alert alert-success center"> Nueva Ruta Optima Creada</div>
                    </div>):(<></>)
                }

              </div>
           </div>
         </div>
         <div className='dashroutesadd_bar_right'>
          <button className='btn-add-guide m-1'>Agregar Guia</button> <button className='btn-add-guide m-1'> Editar Ruta</button>
         </div>
       </div>
      <div className="topflex">
          <div className='dashroutesadd_bar'>  
           <div className='dashroutesadd_bar_top'>
              <div className='dashroutesadd_bar_top_left'>
                <span className='route-name'>{` VEHICULO3 `}</span>
              </div>
              <div className='dashroutesadd_bar_top_right'>
                {
                  bicciOrderExpressGroup?( <span className='min-w-space-flag'><i className="flag icon color-success"></i> - {bicciOrderExpressGroup.length} Asignadas</span>):(<></>)
                }
               
              </div>
           </div>
        
          <div className='dashroutesadd_bar_donw'>
           <div className='dashroutesadd_bar_donw_left'>
             <span>{` Adrian Medina `}</span> <br></br>
             <span>{` Ruta# ${props.match.params.id}`}</span>
           </div>
           <div className='dashroutesadd_bar_donw_right-alt'>
                {
                  targetedOrdersDelivered?( <span className='min-w-space-flag'><i className="flag checkered icon color-solid"></i>  - {targetedOrdersDelivered.length} Entregadas</span>):(<></>)
                }
              
           </div> 
           </div>
         </div>
         <div className='dashroutesadd_bar_donw_right'>
          <button onClick={handleOptimize}> Reordenar Ruta</button>
           
         </div>
     </div>
     <Container  className='containerroutesdispachst' >
     <div className='bar-topflex'>
      <div  className='bar-topflex-left'>

      </div> 
      <div  className='bar-topflex-rigth'>
            {
              visibleMaps?(<button 
                className='btn-maps-routes'
                onClick={handleVisibleMaps}>
                 <i className="map icon font-size-big color-solid"></i>
                 </button>):(<button 
                 className='btn-maps-routes-active'
                 onClick={handleVisibleMaps}>
                <i className="map icon font-size-big color-solid"></i>
                </button>
               )
            }
               
               <button className='btn-routes-save'
                onClick={saveNewRoute}>Guardar Cambios</button>
      </div>
     </div>

     <div className='container-routes'>



      <div className='container-routes-left'>
      <Box sx={{ 
            height: '100%',
            width: '100%',
            backgroundColor: '#fafafa',
            padding:'3px',
            
         }}> 
         {
          targetedOrdersRows.length>0?(<h3>En Ruta</h3>):(<></>)
         }
         
          {
            targetedOrdersRows?(<>
             {
                  targetedOrdersRows.map((item, index) => (
                  <div 
                  key={index} 
                  value={item.id} 
                  className="dispachtelement" 
                  draggable 
                  onDragStart={(e) => dragStart(e, index)}  
                  onDragEnter={(e) => dragEnter(e, index)}
                  onDragEnd={drop}>

                  <span className="whight15">
                  <input
                      className="mininput"
                      type = "number"
                      label=''
                      placeholder='' 
                      onChange={(e) => changeIndex(e, index)}
                      value ={index}
                  ></input>
                  </span>
                  
                  <span className="whight65">{`${item.id}`}</span> 

                  <button
                  className='btn-bicci-small btn-globalhover-calipso btn-floatright whight15'
                  variant="contained"
                  color="primary"
                  size="small"
                  id={targetedOrdersRows.id}
                  style={{ 
                    marginLeft: 1,
                    margin:'3px',
                    padding: '5px',
                    background:'#f8f8f8',
                    color: '#e0557a',
                    borderRadius: '50%',
        
                      }}
                   // onClick={(e)=>handleRemoveItem(e, index)}
                    >
                      <i className="trash alternate outline icon "></i>
                  </button> 

                  <button
                        className='btn-bicci-small btn-globalhover-calipso btn-floatright whight15>'
                        variant="contained"
                        id={targetedOrdersRows.id}
                    
                        style={{ 
                          marginLeft: 1,
                          margin:'3px',
                          padding: '5px',
                          background:'#f8f8f8',
                          color: '#7d0ee6',
                          borderRadius: '50%',
              
                        }}
                        onClick={(e) => handleClickPeriscope(e, item)}
                      >
                      <i className="periscope icon "></i>
                  </button> 
                  
                  </div>
                ))
              
              

             }

              
              </>
              ):(<></>)
          }

      </Box>
      <Box sx={{ 
            height: '100%', 
            width: '100%',
            backgroundColor: '#fafafa',
            padding:'3px',
            
         }}>
          {
          targetedOrdersDelivered.length>0?(<h3>Finalizadas</h3>):(<></>)
          }
         
          {
            targetedOrdersDelivered?(<>
             {
                  targetedOrdersDelivered.map((item, index) => (
                  <div 
                  key={index} 
                  value={item.id} 
                  className="dispachtelement" 
                   
                  >

                  <span className='whight10'>
                  <i className="flag checkered icon color-solid "></i>   
               

                  </span>
                  
                  <span className="whight30">{`${item.id}`}</span> 
                  <span className="dispachtItem dispachtItemStatusSuccess "  >{`Entregada `}</span>
                  <button
                        className='btn-bicci-small btn-globalhover-calipsobtn-floatright whight10'
                        variant="contained"
                        id={targetedOrdersDelivered.id}
                    
                        style={{ 
                          marginLeft: 1,
                          margin:'3px',
                          padding: '5px',
                          background:'#f8f8f8',
                          color: '#7d0ee6',
                          borderRadius: '50%',
              
                        }}
                        onClick={(e) => handleClickPeriscope(e, item)}
                      >
                      <i className="periscope icon "></i>
                  </button> 
                  
                  </div>
                ))
              
              

             }

              
              </>
              ):(<></>)
          }
          
      </Box>
      <Box sx={{ 
            height: '100%', 
            width: '100%',
            backgroundColor: '#fafafa',
            padding:'3px',
            
         }}> 
          {
            targetedOrdersCancel.length>0?(<h3>No Entregadas</h3>):(<></>)
          }
          
          {
            targetedOrdersCancel?(<>
             {
                  targetedOrdersCancel.map((item, index) => (
                  <div 
                  key={index} 
                  value={item.id} 
                  className="dispachtelement" 
                   
                  >

                  <span>
                  <FmdBadIcon className="FmdBadIconIsuress "/>   
                  

                  </span>
                  
                  <span >{`${item.id}`}</span> 
                  <span className="dispachtItem dispachtItemStatusIsuress " >{`Incidencia `}</span>
                  <button
                        className='btn-bicci-small btn-globalhover-calipsobtn-floatright '
                        variant="contained"
                        id={targetedOrdersCancel.id}
                    
                        style={{ 
                          marginLeft: 1,
                          margin:'3px',
                          padding: '5px',
                          background:'#f8f8f8',
                          color: '#7d0ee6',
                          borderRadius: '50%',
              
                        }}
                        onClick={(e) => handleClickPeriscope(e, item)}
                      >
                      <i className="periscope icon "></i>
                  </button> 
                  
                  </div>
                ))
              
              

             }

              
              </>
              ):(<></>)
          }
          
      </Box>
      </div>


      <div className='container-routes-right'>
            {
              visibleMaps?(<>
              <div className='container-routes-right-alt'>
              {
              newwayPoints?(updateMaps()):(<></>)
              }
           </div></>):(<><div className='container-routes-right-alt'>
        <Box sx={{ 
            height: 100, 
            width: '100%',
            backgroundColor: '#fafafa',
            padding:'3px',
            
         }}>
        <h2 className="subtitledispatches">Ordenes de ruta</h2>
         <div 
           className="dispachtelemenTitle">
      
                  <div className="dispachtItem " >{`Estatus Actual`}</div>
                  <div className="dispachtItem">
                  Posición
                  </div>
                  <div className="dispachtItem ">{`ID`}</div> 
                  <div className="dispachtItem-name">
                    
                    <div>{`Nombre `}</div>
                    <div>{`Telefono `}</div>
                    
                  </div> 
                  <div className="dispachtItem"></div> 
                  <div className="dispachtItem">{`Destino `}</div> 
                   
                  
         </div>
         </Box>
         <Box sx={{ 
            height: 400, 
            width: '100%',
            backgroundColor: '#fafafa',
            padding:'3px',
          }}> 
          {
          targetedOrdersRows.length>0?(<h3 className="subtitledispatches">Pendientes por entregar</h3>):(<></>)
          }
          {
            targetedOrdersRows?(<>
             {
                  targetedOrdersRows.map((item, index) => (
                  <div 
                  key={index} 
                  value={item.id} 
                  className="dispachtelementrow" 
                  draggable 
                  onDragStart={(e) => dragStart(e, index)}  
                  onDragEnter={(e) => dragEnter(e, index)}
                  onDragEnd={drop}>
                  <div className="dispachtItem"><DragHandleIcon></DragHandleIcon> </div>
                      
                  <div className="dispachtItem dispachtItemStatus" >{`En trancito `}</div>

                  <div className="dispachtItem">
                  <input
                      className="mininput"
                      type = "number"
                      label=''
                      placeholder='' 
                      onChange={(e) => changeIndex(e, index)}
                      value ={index}
                  ></input>
                  </div>
                  
                  <div className="dispachtItem badge-info dispachtItem-id">{`${item.id}`}</div> 
                  <div className="dispachtItem-name">
                    <div className="dispachtitemspan-name">{`${item.userName} `}</div>
                    <div className="dispachtitemspan-phone ">{`${item.userPhone} `}</div>
                  </div> 
                   
                  <div className="dispachtItem">{`${item.estimatedDeliveryTime} Hrs `}</div>  

                  <div className="dispachtItem">{`${item.toAddress} `}</div> 
                  <div className="dispachtItem inlineflex">
                  <div className='btn-bicci-small btn-globalhover-calipso  '>
                    {
                    item.express?(<span className="badge-success">Express</span>):(<><i className="flag icon color-success padding5"></i></>)
                    }</div> 

                  <button
                  className='btn-bicci-small btn-globalhover-calipso '
                  variant="contained"
                  color="primary"
                  size="small"
                  id={targetedOrdersRows.id}
                  style={{ 
                    marginLeft: 1,
                    margin:'3px',
                    padding: '5px',
                    background:'#f8f8f8',
                    color: '#e0557a',
                    borderRadius: '50%',
        
                      }}
                    onClick={(e)=>handleRemoveItem(e, index)}
                    >
                      <i className="trash alternate outline icon "></i>
                  </button> 

                  <button
                        className='btn-bicci-small btn-globalhover-calipso '
                        variant="contained"
                        id={targetedOrdersRows.id}
                    
                        style={{ 
                          marginLeft: 1,
                          margin:'3px',
                          padding: '5px',
                          background:'#f8f8f8',
                          color: '#7d0ee6',
                          borderRadius: '50%',
              
                        }}
                        onClick={(e) => handleClickPeriscope(e, item)}
                      >
                      <i className="periscope icon "></i>
                  </button> 
                  </div>
                  </div>
                ))
             }
              </>
              ):(<></>)
          }
         </Box>
         <Box sx={{ 
            height: '100%', 
            width: '100%',
            backgroundColor: '#fafafa',
            padding:'3px',
            
          }}>
          {
          targetedOrdersDelivered.length>0?(<h3 className="subtitledispatches">Finalizadas</h3>):(<></>)
          }
         
          {
           targetedOrdersDelivered?(<>
            {
                 targetedOrdersDelivered.map((item, index) => (
                 <div 
                 key={index} 
                 value={item.id} 
                 className="dispachtelementrow" 
                 >
                 <span >{` `}</span>
                 <i className="flag checkered icon color-solid"></i>   
                 <span className="dispachtItem dispachtItemStatusSuccess" >{`Entregada `}</span>

                 <span className="dispachtItem">
               
                 </span>
                 
                 <div className="dispachtItem badge-info dispachtItem-id">{`${item.id}`}</div> 
                 <div className="dispachtItem-name">
                   <div className="dispachtitemspan-name">{`${item.userName} `}</div>
                   <div className="dispachtitemspan-phone ">{`${item.userPhone} `}</div>
                 </div> 
                 <div className="dispachtItem"></div> 
                 <div className="dispachtItem">{`${item.toAddress} `}</div> 
                 <div className='btn-bicci-small btn-globalhover-calipso  btn-floatright '>
                   {
                   item.express?(<span className="badge-success">Express</span>):(<></>)
                   }</div> 
                 <button
                       className='btn-bicci-small btn-globalhover-calipso  btn-floatright '
                       variant="contained"
                       id={targetedOrdersDelivered.id}
                   
                       style={{ 
                         marginLeft: 1,
                         margin:'3px',
                         padding: '5px',
                         background:'#f8f8f8',
                         color: '#7d0ee6',
                         borderRadius: '50%',
             
                       }}
                       onClick={(e) => handleClickPeriscope(e, item)}
                     >
                     <i className="periscope icon "></i>
                 </button> 
                 
                 </div>
               ))
             
             

            }

             
             </>
             ):(<></>)
          }
          
         </Box>
         <Box sx={{ 
            height: '100%', 
            width: '100%',
            backgroundColor: '#fafafa',
            padding:'3px',
            
            
         }}> 
          {
            targetedOrdersCancel.length>0?(<h3 className="subtitledispatches">No Entregadas</h3>):(<></>)
          }
          
          {
         targetedOrdersCancel?(<>
          {
               targetedOrdersCancel.map((item, index) => (
               <div 
               key={index} 
               value={item.id} 
               className="dispachtelementrow" 
               >
               <span >{` `}</span>
               <FmdBadIcon className="FmdBadIconIsuress"/>   
               <span className="dispachtItem dispachtItemStatusIsuress" >{`Incidencia `}</span>

               <span className="dispachtItem">
            
               </span>
               
               <div className="dispachtItem badge-info dispachtItem-id">{`${item.id}`}</div> 
               <div className="dispachtItem-name">
                 <div className="dispachtitemspan-name">{`${item.userName} `}</div>
                 <div className="dispachtitemspan-phone ">{`${item.userPhone} `}</div>
               </div> 
               <div className="dispachtItem"></div> 
               <div className="dispachtItem">{`${item.toAddress} `}</div> 
               <div className='btn-bicci-small btn-globalhover-calipso  btn-floatright  '>
                 {
                 item.express?(<span className="badge-success">Express</span>):(<></>)
                 }</div> 

              

               <button
                     className='btn-bicci-small btn-globalhover-calipso btn-floatright '
                     variant="contained"
                     id={targetedOrdersCancel.id}
                 
                     style={{ 
                       marginLeft: 1,
                       margin:'3px',
                       padding: '5px',
                       background:'#f8f8f8',
                       color: '#7d0ee6',
                       borderRadius: '50%',
           
                     }}
                     onClick={(e) => handleClickPeriscope(e, item)}
                   >
                   <i className="periscope icon "></i>
               </button> 
               
               </div>
             ))
           
           

          }

           
           </>
           ):(<></>)
          }
          
         </Box>
       </div></>)
            }
      </div>
     </div>
    </Container> 
    </div>
    ):(<>Cargando</>); 
  };



export default DashRoutesAdd